export default __webpack_public_path__ + "static/media/non.7b51b699.png";